import config from '../config'
import http from '../http'

export default{
	
	updateItemSku:async function(payload) {
		const res = await http({
			url: config.UPDATA_ITEMSKUONLINE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	updateVariationSku:async function(payload) {
		const res = await http({
			url: config.UPDATA_CHILDREN_SKU,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getBindItems:async function(payload) {
		const res = await http({
			url: config.GET_BIND_ITEM_INFO,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	getProductByGroupId:async function(payload) {
		console.log(payload)
		const res = await http({
			url: config.GET_GROUNPID_INFO,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	getOnlineGoods:async function(payload) {
		const res = await http({
			url: config.GET_ONLIONE_GOODS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getOrderTime:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_ORDER_TIME,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//匹配SKU绑定仓库商品
	bindBYsku:async function(payload) {
		const res = await http({
			url: config.BIND_BY_SKU,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//批量生成仓库产品
	batchCreateStoreItem:async function(payload) {
		const res = await http({
			url: config.BATCH_CREATE_STORE_ITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取商店商品的所有类目信息
	getCategoryByshop:async function(payload) {
		const res = await http({
			url: config.GET_CATEGOR_BY_SHOP,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取库存周转
	getInventoryTurnover:async function(payload) {
		const res = await http({
			url: config.GET_INVENTORY_TURNOVER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取商品销售情况 
	getItemSales:async function(payload) {
		const res = await http({
			url: config.GET_ITEM_SALES,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	//获取我的商品下店铺商品的总数
	getShopAllItemtotal:async function(payload) {
		const res = await http({
			url: config.GET_SHOP_ITEMS_TOTAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取商店内所有的商品信息
	getShopAllItems: async function(payload) {
		const res = await http({
			url: config.GET_SHOP_ITEMS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	//加入仓库
	addGoodsInStore: async function(payload) {
		const res = await http({
			url: config.ADD_SHOP_IN_STORE,
			method: 'post',
			data: payload

		})
		return res.data
	},

	//加入单品库
	addNotProductInStore: async function(payload) {
		const res = await http({
			url: config.ADD_NOT_PRODUCT_IN_STORE,
			method: 'post',
			data: payload

		})
		return res.data
	},
	
	//同步同步shopee产品
	tongBuShopee: async function(payload) {
		const res = await http({
			url: config.TONG_BU_SHOPEE_ITEM,
			method: 'post',
			data: payload
	
		})
		return res.data
	},
	
	//获取LAZADA平台下的仓库商品
	getLazadaWarehouseitems:async function(payload) {
		const res = await http({
			url: config.GET_LAZADA_SHOP_ITEMS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	
	tongBuLazada: async function(payload) {
		const res = await http({
			url: config.TONG_BU_LAZADA_ITEM,
			method: 'post',
			data: payload
	
		})
		return res.data
	},
	

	

	
	
}